import { TextArea } from 'grommet'

export default TextArea
